import {
  FETCH_INSTALLED_VERSIONS,
  FETCH_INSTALLED_VERSIONS_FAILURE,
  FETCH_INSTALLED_VERSIONS_SUCCESS,
  OPEN_INSTALLED_VERSIONS_MODAL,
} from '../actions/InstalledVersionsActions';
import { SET_ID_MENU_MODAL_DIALOG, SET_OPEN_MENU_MODAL_DIALOG } from '../actions/MenuDialogActions';
import {
  FETCH_CREATE_PAT,
  FETCH_CREATE_PAT_FAILURE,
  FETCH_CREATE_PAT_SUCCESS,
  FETCH_REVOKE_PAT,
  FETCH_REVOKE_PAT_FAILURE,
  FETCH_REVOKE_PAT_SUCCESS,
} from '../actions/PatActions';
import {
  CLEAR_TOP_MENU_MODAL,
  CLOSE_TOP_MENU_MODAL,
  FETCH_MENU_OPTIONS,
  FETCH_MENU_OPTIONS_FAILURE,
  FETCH_MENU_OPTIONS_SUCCESS,
  SET_CLEAR_OPTIONS,
  SET_SEARCH_OPTIONS,
  SET_SEARCH_TEXT,
} from '../actions/TopMenuActions';

const initialState = {
  fetchedOptions: false,
  searchText: '',
  searchTextOptions: [],
  pageNumber: 0,
  searchOptions: [],
  createPat: {
    isOpen: false,
    message: '',
    pat: '',
  },
  revokePat: {
    isOpen: false,
    message: '',
  },
  fetchedInstalledVersions: false,
  installedVersions: {
    columns: [],
    isOpen: false,
    rows: [],
  },
  menuModalDialog: {
    isOpen: false,
    menuId: null,
  },
};

const topMenuReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MENU_OPTIONS:
      return {
        ...state,
        fetchedOptions: initialState.fetchedOptions,
        searchOptions: initialState.searchOptions,
      };

    case FETCH_MENU_OPTIONS_SUCCESS:
      return {
        ...state,
        fetchedOptions: true,
        searchOptions: action.menuOptions || [],
      };

    case FETCH_CREATE_PAT:
      return {
        ...state,
        createPat: {
          ...state.createPat,
          isOpen: true,
        },
      };

    case FETCH_CREATE_PAT_SUCCESS:
      return {
        ...state,
        createPat: {
          ...state.createPat,
          message: action.message,
          pat: action.pat,
        },
      };

    case FETCH_REVOKE_PAT:
      return {
        ...state,
        revokePat: {
          ...state.revokePat,
          isOpen: true,
        },
      };

    case SET_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.searchText,
        pageNumber: 1,
        searchTextOptions: [],
      };

    case SET_SEARCH_OPTIONS:
      return {
        ...state,
        searchTextOptions: [...state.searchTextOptions, ...(action.searchTextOptions || [])],
        pageNumber: state.pageNumber + 1,
      };

    case SET_CLEAR_OPTIONS:
      return {
        ...state,
        searchTextOptions: [],
        pageNumber: 1,
      };

    case FETCH_REVOKE_PAT_SUCCESS:
      return {
        ...state,
        revokePat: {
          ...state.revokePat,
          message: action.message,
        },
      };

    case OPEN_INSTALLED_VERSIONS_MODAL:
      return {
        ...state,
        installedVersions: {
          ...state.installedVersions,
          isOpen: true,
        },
      };
    case FETCH_INSTALLED_VERSIONS:
      return {
        ...state,
        installedVersions: {
          ...state.installedVersions,
        },
      };

    case FETCH_INSTALLED_VERSIONS_SUCCESS:
      return {
        ...state,
        fetchedInstalledVersions: true,
        installedVersions: {
          ...state.installedVersions,
          columns: action.columns,
          rows: action.rows,
        },
      };

    case FETCH_CREATE_PAT_FAILURE:
    case FETCH_REVOKE_PAT_FAILURE:
    case CLEAR_TOP_MENU_MODAL:
      return {
        ...state,
        createPat: initialState.createPat,
        revokePat: initialState.revokePat,
      };

    case CLOSE_TOP_MENU_MODAL:
      return {
        ...state,
        createPat: {
          ...state.createPat,
          isOpen: false,
        },
        revokePat: {
          ...state.revokePat,
          isOpen: false,
        },
        installedVersions: {
          ...state.installedVersions,
          isOpen: false,
        },
      };

    case SET_OPEN_MENU_MODAL_DIALOG:
      return {
        ...state,
        menuModalDialog: {
          ...state.menuModalDialog,
          isOpen: action.isOpen,
        },
      };

    case SET_ID_MENU_MODAL_DIALOG:
      return {
        ...state,
        menuModalDialog: {
          ...state.menuModalDialog,
          menuId: action.id,
        },
      };

    case FETCH_INSTALLED_VERSIONS_FAILURE:
    case FETCH_MENU_OPTIONS_FAILURE:
    default:
      return state;
  }
};

export default topMenuReducer;
